// 巡检报告
import React, { useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { theme, Card, Input, Table, App, Pagination, Radio, Space, Button } from 'antd';
import { getInspectionReportFun, getReportFun } from '@/server/inspection_report'
import { basicPath } from '@/router/config';//引入路由基础路径
import DownloadFile from './download_file'

function InspectionReport (props) {
  const location = useLocation();//接受传值数据
  const navigate = useNavigate();//路由跳转
  const limitsAuthority = useRef()//权限列表
  const token = localStorage.getItem('dock_token');
  const {
    token: { colorText },
  } = theme.useToken(); //获取主题颜色
  const { message } = App.useApp();

  const searchInput = useRef(null);//搜索框数据
  const [siftData, setSiftData] = useState({
    type: 1,
    current: 1,
    pageSize: 10,
  });//筛选数据
  const [types, setTypes] = useState([
    {
      label: '常规巡检',
      value: 1,
    },
  ]);// 巡检类型
  const [loading, setLoading] = useState(false);//加载
  const [tableData, setTableData] = useState([]);//表格数据
  const [total, setTotal] = useState(0);//总条数

  //下载文件弹窗参数
  const modelType = useRef(0);//弹窗类型 1、下载报告  2、导出图片
  const [modelOpen, setModelOpen] = useState(false);
  const [modelTitle, setModelTitle] = useState('');
  const [modelBtnLoading, setModelBtnLoading] = useState(false);
  const [modelContent, setModelContent] = useState('');//内容

  const fileName = useRef('');// 文件名称
  const downloadFileUrl = useRef('');// 文件地址

  // 输入框搜索
  const handleSearch = (confirm, dataIndex) => {
    confirm();
  };

  //重置
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
  };
  //姓名、手机 输入框搜索
  const getColumSearch = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      < div className='pd8' onKeyDown={(e) => e.stopPropagation()} >
        <div>
          <Input ref={searchInput}
            placeholder={`搜索 ${dataIndex}`}
            value={selectedKeys}
            onChange={(e) => setSelectedKeys(e.target.value ? e.target.value : null)}
            onPressEnter={() => handleSearch(confirm)}
          />
        </div>

        <Space className='pdT8 flex jcsb'>
          <Button
            type="primary"
            onClick={() => handleSearch(confirm)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            搜索
          </Button>
          <Button
            onClick={() => handleReset(clearFilters, confirm)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>
        </Space>
      </ div >
    ),
    filterIcon: (filtered) => (<SearchOutlined style={{ color: filtered ? '#1890ff' : '' }} />),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  })

  //表格头
  const columns = [
    {
      title: '航线名称',
      dataIndex: 'routes_name',
      ...getColumSearch('航线名称')
    },
    {
      title: '总里程(km)',
      dataIndex: 'routes_len',
    },
    {
      title: '巡检开始时间',
      dataIndex: 'start_time',
      render: (text, item) => {
        return (
          <>
            {
              item.start_time
                ? (
                  <div>
                    <span className='fSize14 opacity0_85 margR8'>{item.start_time.split(' ')[0]}</span>
                    <span className='fSize14 opacity0_45'>{item.start_time.split(' ')[1]}</span>
                  </div>
                )
                : (
                  <span className='opa25'>-</span>
                )
            }
          </>
        );
      },
    },
    {
      title: '巡检结束时间',
      dataIndex: 'endtime',
      render: (text, item) => {
        return (
          <>
            {
              item.endtime
                ? (
                  <div>
                    <span className='fSize14 opacity0_85 margR8'>{item.endtime.split(' ')[0]}</span>
                    <span className='fSize14 opacity0_45'>{item.endtime.split(' ')[1]}</span>
                  </div>
                )
                : (
                  <span className='opa25'>-</span>
                )
            }
          </>
        );
      },
    },
    {
      title: '下载报告',
      dataIndex: 'reportfile',
      width: 120,
      align: 'center',
      render: (text, record) => (
        <div style={{ display: Number(record.generate_report) ? 'block' : 'none', color: '#1890FF' }} className='pointer'
          onClick={() => {
            downloadReport(record.id);
          }}>
          下载报告
        </div>
      ),
    },
  ];

  //获取表格数据
  const getTableData = async (info) => {
    setLoading(true);
    let params = {
      access_token: token,
      title: info.title,
      type: info.type,
      page: info.current,
      perpage: info.pageSize,
    }
    let res = await getInspectionReportFun(params);
    setLoading(false);
    if (res.ret !== 200) {
      message.warning(res.msg || '服务器开了小差，请重试');
      return;
    }
    let tab = [];
    if (res.data.items && res.data.items.length > 0) {
      for (let i = 0; i < res.data.items.length; i++) {
        tab.push(res.data.items[i]);
      }
    }
    setTotal(res.data.total);
    setTableData(tab);

  }

  //获取报告
  const downloadReport = async (id) => {
    setModelOpen(true);
    setModelBtnLoading(true);
    modelType.current = 1;
    setModelTitle('下载报告文件');
    setModelContent('正在从服务器获取报告文件，请稍等...');
    const res = await getReportFun({
      access_token: token,
      statid: id,
      insId: 0
    });
    console.log(res);
    setModelContent('报告文件已准备，点击按钮下载');
    setModelBtnLoading(false);
    if (res.ret !== 200) {
      message.warning(res.msg || '数据跑丢了~');
      setModelOpen(false);
      return;
    }
    message.success('获取报告成功');
    if (res.data.reportfile_url && modelType.current === 1) {
      fileName.current = res.data.file_name || '巡检报告';
      downloadFileUrl.current = res.data.reportfile_url;
    }
  }

  useEffect(() => {
    limitsAuthority.current = JSON.parse(localStorage.getItem('dock_AirportPermissionsArr'));
    console.log(JSON.parse(localStorage.getItem('dock_AirportPermissionsArr')));
    let sift = { ...siftData };
    sift.type = (limitsAuthority.current)?.indexOf(116) > -1 ? 1 : 0;
    setSiftData(sift);
    getTableData(sift);
    //eslint-disable-next-line
  }, [])

  return (
    <Card style={{ border: 0 }} className="mar24" styles={{ body: { padding: '24px' } }}>
      <a id='a_report' href='undefined' download="巡检报告.docx" style={{ display: 'none' }}>
        查看
      </a>
      <div className='flex-auto backcol marB12'>
        <Radio.Group optionType="button" onChange={(e) => {
          let sift = { ...siftData };
          sift.page = 1;
          sift.type = e.target.value;
          setSiftData(sift);
          getTableData(sift);
        }} value={siftData.type} >
          <Radio style={{ display: (limitsAuthority.current)?.indexOf(116) > -1 ? `` : `none` }} value={1}>管道巡检</Radio>
        </Radio.Group>
      </div>
      <Table
        columns={columns}
        dataSource={tableData}
        pagination={false}
        loading={loading}
        rowKey='id'
        onChange={(pagination, filters, sorter) => {
          console.log(pagination, filters, sorter);
          let sift = { ...siftData };
          sift.current = 1;
          sift.title = filters.routes_name;
          setSiftData(sift);
          getTableData(sift);
        }}
      >
      </Table>

      {/* 下标 */}
      <div className='pdT16'>
        <Pagination align='end' current={siftData.current} pageSize={siftData.pageSize} total={total} showTotal={total => `共 ${total} 条数据`}
          onChange={
            (current, pageSize) => { //选择当前页后执行
              let sift = { ...siftData };
              sift.current = current;
              sift.pageSize = pageSize;
              setSiftData(sift)
              getTableData(sift);
            }
          } />
      </div>
      <DownloadFile open={modelOpen} btnLoading={modelBtnLoading} title={modelTitle}
        content={modelContent}
        fileName={fileName.current}
        downloadFileUrl={downloadFileUrl.current}
        close={() => {
          setModelOpen(false);
        }}
      ></DownloadFile>
    </Card>

  )
}
export default InspectionReport